import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { GruppoDiRicercaFormType, ImmagineFormType, Persona } from "../../types"
import ImmagineForm from "./GruppoDiRicercaForm"
import { useNavigate, useParams } from "react-router-dom"
import { useImmagine, useImmagineDelete, useImmaginePartialUpdate } from "../../hooks/immagini"
import { Formik } from "formik"
import { initialValuesGruppo, validationSchemaGruppo } from "./GruppoDiRicercaCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"
import { useGruppoDiRicerca, useGruppoDiRicercaDelete, useGruppoDiRicercaPartialUpdate } from "../../hooks/gruppi-di-ricerca"
import GruppoDiRicercaForm from "./GruppoDiRicercaForm"

export default function GruppoDiRicercaUpdate() {
  const updateGruppo = useGruppoDiRicercaPartialUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: gruppo } = useGruppoDiRicerca(Number(id))

  useBreadcrumbs([{ label: "Gruppi di ricerca", href: "/gruppi-di-ricerca/gruppi-di-ricerca" }, { label: gruppo?.nome || "..." }])

  const [modalStateDeleteGruppo, modalActionsDeleteGruppo] = useModalTrigger()

  const deleteGruppo = useGruppoDiRicercaDelete()

  const initialValues = useMemo(() => initialValuesGruppo(gruppo), [gruppo])
  const validationSchema = useMemo(() => validationSchemaGruppo(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{gruppo?.nome || "..."}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteGruppo.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              const payload = { ...values }
              if(typeof payload.immagine === "string") {
                delete payload.immagine
              }
              return updateGruppo.mutateAsync(payload as GruppoDiRicercaFormType).then((gruppo) => {
                navigate(`/gruppi-di-ricerca/gruppo-di-ricerca/${gruppo.id}`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <GruppoDiRicercaForm col={8} />
                </Container>
                <BottomFormFixed url="/gruppi-di-ricerca/gruppi-di-ricerca" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteGruppo.isOpen}
        onClose={modalActionsDeleteGruppo.close}
        onDelete={() => {
          return deleteGruppo.mutateAsync(gruppo?.id).then(() => {
            navigate(`/gruppi-di-ricerca/gruppi-di-ricerca`)
          })
        }}
        message="Sei sicuro di voler eliminare questa persona del gruppo di ricerca?"
        title="Elimina persona del gruppo di ricerca"
      />
    </Layout>
  )
}
